import PageMusic from "../../page-music/PageMusic";

const Music = () => {
    return (
        <PageMusic />
    );
}

export default Music;